var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.1282 27.1329L1.44975 45.036C1.20214 45.1717 1.19246 45.3988 1.42821 45.5415L27.0577 61.0474C27.2929 61.1897 27.6821 61.1933 27.925 61.0555L60.557 42.5338C60.8008 42.3955 60.8032 42.1679 60.5624 42.0278L34.9794 27.1403C34.7457 27.0044 34.3688 27.0011 34.1282 27.1329Z",
    fill: "#00004B",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.3755 56.2449L60.6756 37.7792C60.9095 37.6455 61.0413 37.4626 61.0413 37.2718L61.0413 34.3409C61.0413 34.1485 60.9074 33.9643 60.67 33.8303L36.9039 20.4152C36.4188 20.1414 35.6438 20.1486 35.1741 20.4314L32.388 22.1084L1.40608 38.367C1.14907 38.5018 1.00236 38.6938 1.00236 38.8952L1.00236 41.306C1.00236 41.497 1.13447 41.6801 1.36893 41.8139L26.6631 56.2454C27.1388 56.5168 27.9003 56.5166 28.3755 56.2449Z",
    fill: "#38C7AE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6957 19.3303L1.4612 38.0877C0.983849 38.3654 0.98385 38.8158 1.4612 39.0936L26.62 53.7336C27.0974 54.0114 27.8713 54.0114 28.3487 53.7336L60.5831 34.9762C61.0605 34.6984 61.0605 34.2481 60.5831 33.9703L35.4243 19.3303C34.947 19.0525 34.173 19.0525 33.6957 19.3303Z",
    fill: "#5AF7DC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0734 30.1824L20.1103 49.9456L26.6198 53.7336C27.0972 54.0113 27.8711 54.0113 28.3484 53.7336L60.5829 34.9762C61.0603 34.6984 61.0603 34.2481 60.5829 33.9703L54.0734 30.1824Z",
    fill: "#4AEBCF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.9743 16.5539L2.39319 34.9311C2.34545 34.9589 2.34545 35.0039 2.39319 35.0317L14.8877 42.3023C14.9831 42.3579 15.1379 42.3579 15.2334 42.3023L46.7281 23.9754C46.8236 23.9199 46.8236 23.8298 46.7281 23.7742L34.32 16.5539C34.2246 16.4984 34.0698 16.4984 33.9743 16.5539Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5636 24.0952L15.4985 42.1721C15.3445 42.2617 15.0812 42.1982 15.0812 42.0715L15.0813 20.7429C15.0813 20.541 15.2288 20.3486 15.4869 20.2137L46.7177 3.88991C46.7964 3.84878 46.9216 3.88128 46.9216 3.94282L46.9216 23.5922C46.9216 23.7809 46.7928 23.9618 46.5636 24.0952Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5079 18.4078L15.0108 20.4872M10.2503 18.2714L40.2233 1.43193C40.3115 1.38241 40.4561 1.43074 40.427 1.49999L34.2273 16.2594C34.1742 16.3858 34.0624 16.5014 33.9042 16.5934L2.62972 34.7922C2.54118 34.8437 2.39261 34.7937 2.42529 34.7233L9.91937 18.5974C9.97703 18.4733 10.0914 18.3607 10.2503 18.2714Z",
    stroke: "white",
    strokeOpacity: 0.8,
    strokeWidth: 1.4,
    strokeMiterlimit: 10,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.0287 0.757492L41.2519 0.307612C41.0917 0.22689 40.9009 0.238863 40.7519 0.338986L41.0287 0.757492ZM47.0326 3.78338L47.2558 4.23326C47.4248 4.14806 47.5316 3.97389 47.5316 3.78338C47.5316 3.59286 47.4248 3.4187 47.2558 3.3335L47.0326 3.78338ZM40.7519 0.338986L39.2509 1.34761L39.8045 2.18463L41.3055 1.176L40.7519 0.338986ZM45.2545 5.24189L47.2558 4.23326L46.8094 3.3335L44.8081 4.34212L45.2545 5.24189ZM47.2558 3.3335L41.2519 0.307612L40.8056 1.20737L46.8094 4.23326L47.2558 3.3335Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 1.92307,
    ry: 1.92307,
    transform: "matrix(0.864316 -0.502949 0.864316 0.502949 30.0921 31.6035)",
    fill: "#042848"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.5217,
    cy: 22.9473,
    rx: 2.50162,
    ry: 2.52157,
    fill: "white",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 62,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNet);
export default __webpack_public_path__ + "static/media/net.c3591bcaf3a53d945354e7b612220232.svg";
export { ForwardRef as ReactComponent };